import { Languages } from "../types/common";
import { languages } from "../utils/commonUtil";

class LanguageService {
  static fetchSystemLanguage() {
    // Check localStorage or system preference
    const savedLanguage = localStorage.getItem(
      "i18nextLng"
    ) as Languages | null;

    if (savedLanguage) {
      return savedLanguage;
    }

    const languageCode = navigator.languages
      ? navigator.languages[0]
      : navigator.language;
    return languageCode.startsWith(languages.da) ? languages.da : languages.en;
  }
}

export default LanguageService;
